import PropTypes from "prop-types";
import Checkbox from "@mui/material/Checkbox";

function RemoveRestoreBvCheckbox({ backendVariableSettings }) {
    const { removedKpi, setRemovedKpi, backendVariable, mappings } = backendVariableSettings;
    const getBackendVariable = (bv) => {
        const flatArr = mappings.flatMap((datum) => datum.displayLabels);
        const obj = flatArr.find((ele) => ele.backendVariable === bv);
        const dl = obj?.displayLabel;
        if (dl) {
            // Return all backendVariables with the same displayLabel
            return flatArr.filter((ele) => ele.displayLabel === dl).map((ele) => ele.backendVariable);
        }
        // If not found, return the original bv wrapped in an array
        return [bv];
    };

    const handleChange = (e) => {
        const checked = e.target.checked;
        const targetValue = e.target.value;
        const arrSet = new Set(removedKpi);
        if (checked) {
            arrSet.add(targetValue);
        } else {
            arrSet.delete(targetValue);
        }
        setRemovedKpi(Array.from(arrSet));
    };
    const checkboxValue = getBackendVariable(backendVariable).join(",");
    return (
        <Checkbox
            sx={{
                "&.Mui-checked": {
                    color: "red",
                },
                "& .MuiSvgIcon-root": {
                    fontSize: 18,
                },
                padding: 0,
                marginRight: "5px",
                position: "relative",
                top: "-1px",
            }}
            color="secondary"
            checked={removedKpi.includes(checkboxValue)}
            onChange={handleChange}
            value={checkboxValue}
        />
    );
}

RemoveRestoreBvCheckbox.propTypes = {
    backendVariableSettings: PropTypes.object,
};

export default RemoveRestoreBvCheckbox;
